// src/utils/accessControl.ts
import { accessDB } from '../db/accessDB';

export async function setAccess(value: boolean) {
  await accessDB.access.clear();
  await accessDB.access.add({ canAccess: value });
}

export async function resetAccess() {
  await accessDB.access.clear();
}
